import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Nosotros from "@/pages/Nosotros";
import Servicios from "@/pages/Servicios";
import ComoFunciona from "@/pages/ComoFunciona";
import Preguntas from "@/pages/Preguntas";
import Postula from "@/pages/Postula";
import Contacto from "@/pages/Contacto";
import Privacidad from "@/pages/Privacidad";
import Terminos from "@/pages/Terminos";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App bg-ivory min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/servicios" element={<Servicios />} />
            <Route path="/como-funciona" element={<ComoFunciona />} />
            <Route path="/preguntas" element={<Preguntas />} />
            <Route path="/postula" element={<Postula />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/privacidad" element={<Privacidad />} />
            <Route path="/terminos" element={<Terminos />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
